export type SerpDifficultyResult = {
  color: string;
  label: string;
};

export const serpDifficuly = (diff: number): SerpDifficultyResult => {
  if (diff >= 0 && diff < 15) {
    return { color: '#008000', label: 'آسان' };
  }
  if (diff >= 15 && diff < 30) {
    return { color: '#10b981', label: 'نسبتا آسان' };
  }
  if (diff >= 30 && diff < 50) {
    return { color: '#dfba03', label: 'امکان پذیر' };
  }
  if (diff >= 50 && diff < 70) {
    return { color: '#f97316', label: 'سخت' };
  }
  if (diff >= 70 && diff < 85) {
    return { color: '#ef4444', label: 'بسیار سخت' };
  }
  return { color: '#b50000', label: 'تقریباً ناممکن' };
};

export const difficulyRanges: [number, number][] = [
  [0, 14],
  [15, 29],
  [30, 49],
  [50, 69],
  [70, 84],
  [85, 100]
];
